<template>
  <div id="phenotype-container" 
    :class="['pa-4', type == 'reservation' ? 'reservation':'']" 
    v-if="getAllPhenotypeOptions() && oidcUser">
    <v-dialog 
      max-width="900"
      v-model="legalInformationDialogVisible"
      :fullscreen="$vuetify.display.mobile"
      :scrollable="true"
      no-click-animation
      >
      <v-card>
        <div class="d-flex flex-row justify-end">
          <v-btn flat icon color="transparent" size="x-small" class="mr-4 mt-4 modal-close" 
            @click="legalInformationDialogVisible = false">
            <v-icon color="primary" size="24" icon="mdi-close"></v-icon>
          </v-btn>
        </div>
        <legal-component/>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmationOpen"
      :fullscreen="$vuetify.display.mobile"
      :width="$vuetify.display.mobile ? '100%' : '753px'"
      class="phenotype-modal"
    >
      <v-card class="px-6 d-flex flex-column">
        <div class="header d-flex flex-row justify-space-between align-center">
          <div class="modal-header mt-4 mb-5">{{ $t('recipient.consents_phenotype_header') }}</div>
          <v-btn data-test-id="modal-close" flat icon color="transparent" size="x-small" class="mr-1 modal-close" @click="confirmationOpen = false">
            <v-icon color="primary" size="24" icon="mdi-close"></v-icon>
          </v-btn>
        </div>
        
        <div class="consent-wrapper text-left mt-8 mb-8" v-if="!hideConsentContent">
						<div class="consent mb-3t" v-for="(consent, index) in consents" :key="index">
							<label class="container input-label mt-2 d-flex flex-row align-star">
								<span v-html="parseConsent(consent)"></span>
								<input type="checkbox"
									v-model="recipient_consents[consent.code].consent_value">
								<span class="checkmark"></span>
							</label>
							
						<div class="validation_consent mt-1 ml-6 text-left" v-if="!validateConsent(consent.code)">
              {{ $t('recipient.consents_validation_empty_msg') }}    
            </div>
						</div>
				</div>
        <div v-else class="py-10 d-flex justify-center align-center">
          <v-progress-circular
							indeterminate
							color="primary"
							size="22"
							width="2"
						></v-progress-circular>
        </div>
        <v-spacer v-if="$vuetify.display.mobile"></v-spacer>
        <div class="modal-buttons text-right">
          <v-btn
            height="40"
            :width="$vuetify.display.mobile ? '100%' : 'auto'"
            color="primary"
            variant="outlined"
            flat
            rounded
            data-test-id="modal-button-cancel"
            class="modal-button-cancel mb-4 mr-md-4 ml-md-0 px-6"
            @click="confirmationOpen = false"
          >{{ $t('recipient.edit_data_btn') }}</v-btn>
          <v-btn
            height="40"
            :width="$vuetify.display.mobile ? '100%' : 'auto'"
            color="primary"
            flat
            rounded
            data-test-id="modal-button-confirm"
            class="modal-button-confirm mb-4 ml-md-0 px-6"
            @click="savePhenotype()"
          >
            <v-progress-circular
							indeterminate
							color="white"
							size="22"
							width="2"
							v-if="loading_save"
						></v-progress-circular>
						<span v-else>{{ $t('recipient.save_data_btn') }}</span>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="goToCartOpen"
      :fullscreen="$vuetify.display.mobile"
      :width="$vuetify.display.mobile ? '100%' : '792'"
      class="go-to-cart-modal"
      >
      <v-card class="px-4 d-flex flex-column">
        <div class="header d-flex flex-row justify-space-between align-center">
          <div class="modal-header mt-4 mb-5">{{ $t('recipient.added_phenotype_header') }}</div>
          <v-btn data-test-id="modal-close" flat icon color="transparent" size="x-small" class="modal-close" @click="goToCartOpen = false">
            <v-icon color="primary" size="24" icon="mdi-close"></v-icon>
          </v-btn>
        </div>
        <div class="modal-text mb-0 mb-md-10" v-if="!hasPhenotypeMode('partner')">
          {{ $t('recipient.added_phenotype_go_to_partner_text') }}
        </div>
        <div class="modal-text mb-0 mb-md-10" v-if="hasPhenotypeMode('partner') && hasPhenotypeMode('own')">
          {{ $t('recipient.added_partner_phenotype_go_next_text') }}
        </div>
        <v-spacer v-if="$vuetify.display.mobile"></v-spacer>
        <div class="modal-buttons text-right">
          <v-btn
            v-if="!hasPhenotypeMode('partner')"
            height="40"
            :width="$vuetify.display.mobile ? '100%' : 'auto'"
            color="primary"
            flat
            rounded
            data-test-id="go-next-button"
            class="mb-4 ml-md-0 px-6"
            @click="goToPartnerPhenotype()"
            >{{ $t('recipient.next') }}</v-btn>
          <v-btn
            v-else
            height="40"
            :width="$vuetify.display.mobile ? '100%' : 'auto'"
            color="primary"
            flat
            rounded
            data-test-id="go-next-button"
            class="mb-4 ml-md-0 px-6"
            @click="returnToRoute()"
            >{{ $t('recipient.next') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <div v-if="returnRoute?.name" class="text-left mb-6">
      <a @click="returnToRoute" class="back-link d-flex flex-row align-center pt-1"><img :src="chevronLeft" class="icon mr-4"/> 
        {{ $t('page.go_back_to') }} {{ returnToLinkName() }}
      </a>
    </div>

    <!-- <div v-if="editMode">
      <h3 class="text-left mt-2">
        {{ hasStoredPhenotype ? $t('recipient.edit_header') : $t('recipient.add_header') }}
        {{ isOwnPhenotype ? $t('recipient.own_phenotype_header') : $t('recipient.partner_phenotype_header') }}
      </h3>
    </div> -->

    <v-alert class="mt-6 mb-4 text-left alert pt-4 pb-4 pl-8 pr-8" :type="alert.type" :color="alert.color"
      :icon="alert.icon" height="auto" min-height="88px" justify="center" v-if="alert.visible">
      {{alert.text}}
    </v-alert>

    <div v-if="!editMode">
      <div v-if="hasStoredPhenotype">
        <show-phenotype :phenotype="storedPhenotype[currentPhenotype]" :material-type="materialType"/>
          <div v-if="!$vuetify.display.mobile" :class="['text-none edit']" @click="editPhenotype">
            {{$t('recipient.edit_phenotype_btn')}}
          </div>
          <v-btn v-else
            class="text-none button mr-md-6 mt-4 long"
            @click="editPhenotype"
            color="primary"
            rounded
            data-test-id="edit-phenotype-button"
            variant="outlined">
            {{$t('recipient.edit_phenotype_data_btn')}}
          </v-btn>
      </div>
    </div>
    <div v-else>

      <div class="filters_header text-left">
        {{ $t('search.filters_header_physical') }}
      </div>

      <v-row class="text-left mt-7 invicta">
        <v-col v-if="genderOptions"
        class="gender pa-0">
          <item-group :name="$t('recipient.phenotype.gender')" v-model="selectedGender" :multiple="false" :options="genderOptions" trans-path="" data-test-id="gender-input" />
          <Tooltip
            :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
            :text="$t(`recipient.phenotype.gender_tooltip`)"
            :icon="true">
          </Tooltip>
          <div class="validation mt-1" v-if="!validateField('selectedGender')">
            {{$t('recipient.phenotype.gender_validation_empty_msg')}}
          </div>
          <div class="validation mt-1" v-if="!validateField('selectedOppositeGender')">
            {{$t('recipient.phenotype.gender_validation_invalid_msg', {gender_adjective: $t(`${selectedGender}_ADJECTIVE`)} )}}
          </div>
        </v-col>
      </v-row>

      <v-row class="text-left mt-9 invicta">
        <v-col cols="12" md="4" v-if="eyeColorOptions"
        class="eye-color pa-0 pb-6 pr-md-1">
          <CustomSelect :name="$t('recipient.phenotype.eye_color')" v-model="selectedEyeColor" :multiple="false" :options="eyeColorOptions" :trans-path="`phenotype.eye_color.${materialType}`" :chip="false" data-test-id="eye-color-input"/>
          <Tooltip
            :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
            :text="$t(`recipient.phenotype.eye-color_tooltip`)"
            :icon="true">
          </Tooltip>
          <div class="validation mt-1" v-if="!validateField('selectedEyeColor')">
            {{$t('recipient.phenotype.eye_color_validation_empty_msg')}}
          </div>

        </v-col>
        <v-col cols="12" md="4" v-if="hairColorOptions"
        class="hair-color pa-0 pb-6 pr-md-1 pl-md-1">
          <CustomSelect :name="$t('recipient.phenotype.hair_color')" v-model="selectedHairColor" :multiple="false" :options="hairColorOptions" :trans-path="`phenotype.hair_color.${materialType}`" :chip="false" data-test-id="hair-color-input"/>
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.hair-color_tooltip`)"
              :icon="true">
            </Tooltip>
          <div class="validation mt-1" v-if="!validateField('selectedHairColor')">
            {{$t('recipient.phenotype.hair_color_validation_empty_msg')}}
          </div>
        </v-col>
        <v-col cols="12" md="4" v-if="hairShapeOptions"
        class="hair-shape pa-0 pb-6 pl-md-1">
          <CustomSelect :name="$t('recipient.phenotype.hair_shape')" v-model="selectedHairShape" :multiple="false" :options="hairShapeOptions" :trans-path="`phenotype.hair_structure.${materialType}`" :chip="false" data-test-id="hair-shape-input" />
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.hair-shape_tooltip`)"
              :icon="true">
            </Tooltip>
          <div class="validation mt-1" v-if="!validateField('selectedHairShape')">
            {{$t('recipient.phenotype.hair_shape_validation_empty_msg')}}
          </div>
        </v-col>
      </v-row>

      <v-row class="text-left mt-9 invicta">
        <v-col cols="12" md="4"
        class="height pa-0 pb-6">
          <div class="label mb-2">{{$t('recipient.phenotype.height')}}</div>
          <v-text-field style="width: 114px;" label="" type="number" min="0" color="secondarybg" bg-color="white" v-model="height"
          placeholder="np. 160"
            :persistent-placeholder="true" density="compact" hide-details="auto" variant="outlined" class="mt-n1" data-test-id="height-input">
            <v-card variant="text" color="primary">{{$t('cm')}}</v-card>
          </v-text-field>
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.height_tooltip`)"
              :icon="true">
            </Tooltip>
          <div class="validation mt-1" v-if="!validateField('height')">
            {{$t('recipient.phenotype.height_validation_empty_msg')}}
          </div>
        </v-col>
        <v-col cols="12" md="4"
        class="weight pa-0 pb-6 pl-md-1">
          <div class="label mb-2">{{$t('recipient.phenotype.weight')}}</div>
          <v-text-field style="width: 114px;" label="" type="number" min="0" color="secondarybg" bg-color="white"   v-model="weight"
            placeholder="np. 48"
            :persistent-placeholder="true" density="compact" hide-details="auto" variant="outlined" class="mt-n1" data-test-id="weight-input">
            <v-card variant="text" color="primary">{{$t('kg')}}</v-card>
          </v-text-field>
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.weight_tooltip`)"
              :icon="true">
            </Tooltip>
          <div class="validation mt-1" v-if="!validateField('weight')">
            {{$t('recipient.phenotype.weight_validation_empty_msg')}}
          </div>
        </v-col>
        <v-col cols="12" md="4"
            class="body-type pa-0 pb-6 pl-md-1">
          <div v-if="bodyTypeOptions">
            <div class="label mb-2">{{ $t('recipient.phenotype.body_type') }}</div>
              <div class="d-flex flex-row" data-test-id="body-type-options">
                <div v-for="(option, index) in
                  bodyTypeOptions"
                  :key="index"
                  :class="$vuetify.display.mobile ? 'filter-mobile-body' : ''">
                  <div
                      :class="['square mr-2', option.key == bodyType ? 'filter_selected' : '']"
                      :id="option.key + (selectedGender == 'MALE' ? '_MALE' : '')"
                    >
                  </div>
                </div>
              </div>
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.body-type_tooltip`)"
              :icon="true">
            </Tooltip>
          </div>
        </v-col>
      </v-row>

      <v-divider class="my-8"></v-divider>

      <div class="filters_header text-left mt-7">
        {{ $t('search.filters_header_blood') }}
      </div>

      <v-row class="text-left mt-7 invicta">
        <v-col cols="12" md="4"
            class="blood-type pa-0 pb-6">
          <div v-if="bloodTypeOptions">
            <item-group :name="$t('recipient.phenotype.blood_type')" v-model="selectedBloodType" :multiple="false"
              :options="bloodTypeOptions"
              :trans-path="`phenotype.blood_type.${materialType}.`" data-test-id="blood-type-input" />
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.blood-type_tooltip`)"
              :icon="true">
            </Tooltip>
          </div>
          <div class="validation mt-1" v-if="!validateField('selectedBloodType')">
            {{$t('recipient.phenotype.blood_type_validation_empty_msg')}}
          </div>
        </v-col>
        <v-col cols="12" md="4"
            class="blood-rh-factor pa-0 pb-6 pl-md-1">
          <div v-if="bloodRhFactorOptions">
            <item-group :name="$t('recipient.phenotype.blood_fh_factor')" v-model="selectedBloodRhFactor" :multiple="false"
              :options="bloodRhFactorOptions"
              :trans-path="`phenotype.blood_rh_factor.${materialType}.`" data-test-id="blood-rh-factor-input" />
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.blood-rh-factor_tooltip`)"
              :icon="true">
            </Tooltip>
          </div>
          <div class="validation mt-1" v-if="!validateField('selectedBloodRhFactor')">
            {{$t('recipient.phenotype.blood_fh_factor_validation_empty_msg')}}
          </div>
        </v-col>
      </v-row>

      <v-divider class="my-8"></v-divider>

      <div class="filters_header text-left mt-7">
        {{ $t('search.filters_header_origins') }}
      </div>

      <v-row class="text-left mt-7 invicta">
        <v-col cols="12" md="4"
            class="race pa-0 pb-6 pr-md-1">
          <CustomSelect
            :name="$t('recipient.phenotype.race')"
            v-model="selectedRace"
            :multiple="false"
            :flat="true"
            :options="raceOptions" :chip="false"
            :trans-path="`phenotype.race.${materialType}`"
            :validation-result="validateField('selectedRace')"
            data-test-id="race-input"/>
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.race_tooltip`)"
              :icon="true">
            </Tooltip>
            <div class="validation mt-1" v-if="!validateField('selectedRace')">
              {{$t('recipient.phenotype.race_validation_empty_msg')}}
            </div>
        </v-col>
        <v-col cols="12" md="4"
            class="skin pa-0 pb-6 pr-md-1 pl-md-1">
          <CustomSelect
            :name="$t('recipient.phenotype.skin_color')"
            v-model="selectedSkinColor"
            :multiple="false"
            :flat="true"
            :options="skinColorOptions" :chip="false"
            :trans-path="`phenotype.skin_color.${materialType}`"
            :validation-result="validateField('selectedSkinColor')"
            data-test-id="skin-color-input"/>
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.skin_tooltip`)"
              :icon="true">
            </Tooltip>
            <div class="validation mt-1" v-if="!validateField('selectedSkinColor')">
              {{$t('recipient.phenotype.skin_color_validation_empty_msg')}}
            </div>
        </v-col>
        <v-col cols="12" md="4"
            class="ethnicity pa-0 pb-6 pl-md-1">
          <CustomSelect
            :name="$t('recipient.phenotype.ethnicity') + ' ' + $t('recipient.phenotype.optional_value')"
            v-model="selectedEthnicity"
            :multiple="false"
            :flat="true"
            :options="ethnicityOptions" :chip="false"
            :trans-path="`phenotype.ethnicity.${materialType}`"
            @click="$refs.secondaryEthnicitySelect ? $refs.secondaryEthnicitySelect.selectedItems = [] : null"
            data-test-id="ethnicity-input"/>
            <Tooltip
              :class="['mr-4 mr-md-2', $vuetify.display.mobile ? '' : 'tooltip-short']"
              :text="$t(`recipient.phenotype.ethnicity_tooltip`)"
              :icon="true">
            </Tooltip>
        </v-col>
      </v-row>
      <v-row class="text-left mt-0">
        <v-col cols="12" md="4" class="pa-0 pr-md-1 pb-6">
          <CustomSelect
            v-if="!(selectedEthnicity.length < 1 || selectedEthnicity[0].key!='POLAND_ETHNICITY')"
            :name="$t('recipient.phenotype.secondary_ethnicity') + ' ' + $t('recipient.phenotype.optional_value')"
            :class="{disabled: (selectedEthnicity.length < 1 || selectedEthnicity[0].key!='POLAND_ETHNICITY')}"
            v-model="selectedSecondaryEthnicity"
            :multiple="true"
            :flat="true"
            :options="secondaryEthnicityOptions" :chip="false"
            :trans-path="`phenotype.subethnicities.${materialType}`"
            ref="secondaryEthnicitySelect"
            data-test-id="secondary-ethnicity-input"/>
        </v-col>
      </v-row>
      <v-row class="text-right mt-8" :class="$vuetify.display.mobile ? 'text-center' : 'text-right'" v-if="!['complete','reservation'].includes(type)">
        <v-col cols="12">
          <v-btn
            class="button mr-md-6 py-2 px-6"
            :class="$vuetify.display.mobile ? 'mb-4 long' : ''"
            @click="confirmPhenotype(true)"
            color="primary"
            variant="outlined"
            data-test-id="confirm-phenotype-and-change-button"
            rounded>
            {{
              isOwnPhenotype  ?
              $t('recipient.save_own_phenotype_and_go_to_partner_btn') :
              $t('recipient.save_partner_phenotype_and_go_to_own_btn')
            }}
          </v-btn>
          <v-btn
            class="button py-2 px-6"
            :class="$vuetify.display.mobile ? 'mb-6 long' : ''"
            color="primary"
            @click="confirmPhenotype(false)"
            rounded
            data-test-id="confirm-phenotype-no-change-button"
          >
            {{$t('recipient.save_phenotype_btn')}}
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="text-right mt-0" :class="$vuetify.display.mobile ? 'text-center' : 'text-right'" v-else>
        <v-col cols="12 pa-0">
          <v-btn
            class="button mr-md-6 py-2 px-6"
            :class="$vuetify.display.mobile ? 'long' : ''"
            @click="confirmPhenotype(true)"
            color="primary"
            height="48"
            data-test-id="next-phenotype-complete-button"
            rounded>
            {{ $t('recipient.next') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, useStore } from "vuex";
import { computed } from "vue";
import ItemGroup from "./ItemGroupComponent";
import CustomSelect from "./CustomSelectComponent";
import { Tooltip } from "design-system-ui-components";
import ShowPhenotype from "./ShowPhenotypeComponent.vue";
import { body_type_list } from "../utils/filter_lists";
import LegalComponent from '@/components/LegalComponent.vue';

export default {
  name: 'RecipientPhenotypeComponent',
  components: {
    ItemGroup,
    CustomSelect,
    ShowPhenotype,
    Tooltip,
    LegalComponent
  },
  props: ['type'],
  data: () => ({
    body_type_list,
    editMode: false,
    materialType: 'mtCell',
    phenotype: {
      "own": {},
      "partner": {},
    },
    oidcUser: computed(() => useStore().getters['oidcStore/oidcUser']),
    storedPhenotype: computed(() => useStore().getters['phenotypeModule/getPhenotype']),
    isOwnPhenotype: computed(() => useStore().getters['phenotypeModule/isOwnPhenotype']),
    hasStoredPhenotype: computed(() => useStore().getters['phenotypeModule/hasCurrentPhenotype']),
    hasPhenotypeMode: (mode) => useStore().getters["phenotypeModule/hasPhenotypeMode"](mode),
    returnRoute: computed(() => useStore().getters['phenotypeModule/getReturnRoute']),
    phenotypeOptions: null,
    genderOptions: null,
    selectedGender: null,
    eyeColorOptions: null,
    selectedEyeColor: [],
    hairColorOptions: null,
    selectedHairColor: [],
    hairShapeOptions: null,
    selectedHairShape: [],
    bloodTypeOptions: null,
    selectedBloodType: null,
    bloodRhFactorOptions: null,
    selectedBloodRhFactor: null,
    bodyTypeOptions: null,
    bodyType: null,
    height: null,
    weight: null,
    ethnicityOptions: null,
    selectedEthnicity: [],
    raceOptions: null,
    selectedRace: [],
    skinColorOptions: null,
    selectedSkinColor: [],
    secondaryEthnicityOptions: null,
    selectedSecondaryEthnicity: [],
    validationOn: false, // turn on after first save attempt, then turn off after success
    genderValidationOn: true, // always true unless we want to turn off this feature
    phenotypeSent: true,
    alert: {
      visible: false
    },
    store: useStore(),
    change: null,
    confirmationOpen: false,
    goToCartOpen: false,
    consents: null,
    recipient_consents: null,
    loading_save: false,
    hideConsentContent: false,
    legalInformationDialogVisible: false
  }),
  computed: {
    ...mapState('phenotypeModule', ['currentPhenotype']),
    chevronLeft() {
      return require('../assets/icons/chevron-left.svg');
    }
  },
  created() {
    this.$watch('$route.params.type', (t) => {
      if (t) {
        this.store.dispatch('phenotypeModule/setCurrentPhenotype', t).then(() => {
          this.editMode = true
        })
      }
    })
    this.$watch('currentPhenotype', () => {
      this.setSelectedPhenotypeOptions({})
      this.resetPhenotype()
      this.getCurrentPhenotype()
      this.editMode = false
      this.alert.visible = false
      window.scrollTo({ top: 0, behavior: 'smooth' });
    })
    this.$watch('selectedGender', (gender) => {
      this.phenotype[this.currentPhenotype].gender = gender ?? null
      this.setBodyType()
    })
    this.$watch('selectedEyeColor', (eyeColor) => {
      this.phenotype[this.currentPhenotype].eyeColor = eyeColor ?? null
    })
    this.$watch('selectedHairColor', (hairColor) => {
      this.phenotype[this.currentPhenotype].hairColor = hairColor ?? null
    })
    this.$watch('selectedHairShape', (hairShape) => {
      this.phenotype[this.currentPhenotype].hairShape = hairShape ?? null
    })
    this.$watch('selectedBloodType', (bloodType) => {
      this.phenotype[this.currentPhenotype].bloodType = bloodType ?? null
    })
    this.$watch('selectedBloodRhFactor', (bloodRhFactor) => {
      this.phenotype[this.currentPhenotype].bloodRhFactor = bloodRhFactor ?? null
    })
    this.$watch('height', (height) => {
      if (height < 0) height, this.height = null
      this.phenotype[this.currentPhenotype].height = height ?? null
      this.setBodyType()
    })
    this.$watch('weight', (weight) => {
      if (weight < 0) weight, this.weight = null
      this.phenotype[this.currentPhenotype].weight = weight ?? null
      this.setBodyType()
    })
    this.$watch('bodyType', (bodyType) => {
      this.phenotype[this.currentPhenotype].bodyType = bodyType ?? null
    })
    this.$watch('selectedEthnicity', (ethnicity) => {
      this.phenotype[this.currentPhenotype].ethnicity = ethnicity[0] ?? null
    })
    this.$watch('selectedRace', (race) => {
      this.phenotype[this.currentPhenotype].race = race[0] ?? null
    })
    this.$watch('selectedSkinColor', (skinColor) => {
      this.phenotype[this.currentPhenotype].skinColor = skinColor[0] ?? null
    })
    this.$watch('selectedSecondaryEthnicity', (secondaryEthnicity) => {
      this.phenotype[this.currentPhenotype].secondaryEthnicity = secondaryEthnicity[0] ?? null
    })
    this.$watch('alert.visible', (visible) => {
      if(visible) {
        setTimeout(() => {
          this.alert.visible = false;
        }, 5000) // time to be determined
      }
    })
    this.$watch('confirmationOpen', (visible) => {
      if (visible) {
        setTimeout(() => { this.onConfirmationOpen() }, 100);
      }
    })
  },
  mounted() {
    this.getCurrentPhenotype();
    Promise.all([
      this.getConsents(),
      this.getRecipientConsents()
    ]).catch((err) => {
      console.error(err);
    })
    this.$store.dispatch('breadcrumbModule/setRoute', [{
        name: 'breadcrumb.want_to_be_a_parent',
        url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
        absolute: true
      },{
        name: 'breadcrumb.dashboard',
        url: '/dashboard?selected=personal-details'
      },
      {
        name: 'breadcrumb.dashboard_labels.phenotype',
        url: ''
      }
    ])
    if(this.type == "complete") {
      this.editMode = true;
    }
  },
  methods: {
    onConfirmationOpen() {
      document.getElementById("link-legal-info").addEventListener('click', 
        (e) => {
          this.legalInformationDialogVisible = true;
          e.preventDefault();
        }
      );
    },
		getConsents() {
			return new Promise((resolve, reject) => {
				axios.get('/api/consents?scope=phenotype')
				.then((response) => {
					this.consents = response.data.consents.sort((a,b) => a.id > b.id);
					resolve(response);
				})
				.catch(error => {
					console.error(error);
					reject(error)
				})
			})
		},
		getRecipientConsents() {
			return new Promise((resolve, reject) => {
				axios.get('/api/consents/check?scope=phenotype')
				.then((response) => {
					this.recipient_consents = response.data.consents;
					resolve(response);
				})
				.catch(error => {
					console.error(error);
					reject(error)
				})
			})
		},
		validateConsent(code) {
			let consent = this.consents.find(c => c.code == code);
			let recipient_consent = this.recipient_consents[code];
			if(consent.phenotype && this.validationOn){
				return recipient_consent.consent_value;
			} else {
				return true;
			}
		},
		parseConsent(consent) {
			let text = consent.content[this.$i18n.locale];
			let reg = new RegExp(/\[\[\[([a-z_]+?)?;(.+?)?\]\]\]/g);
			let match;
			const link_service = `https://bank.invicta.pl${ this.$t('bank_invicta_path.terms_and_conditions') }`;
			const link_legal = `/dashboard?selected=legal-information&_locale=${this.$i18n.locale}`;
      const link_info = `https://bank.invicta.pl${ this.$t('bank_invicta_path.gdpr_policy') }`;
			while ((match = reg.exec(text)) != null) {
				switch(match[1]) {
					case "link_terms": {
						text = text.replace(match[0], `<a id="link-legal-info" href="${link_legal}" class="link" target="_blank">${match[2]}</a>`)
						break;
					}
					case "link_service": {
						text = text.replace(match[0], `<a href="${link_service}" class="link" target="_blank">${match[2]}</a>`)
						break;
					}
					case "link_info": {
						text = text.replace(match[0], `<a href="${link_info}" class="link" target="_blank">${match[2]}</a>`)
						break;
					}
				}
			}
			return text + (consent.phenotype ? '*' : '');
		},
		sendConsent() {
      return new Promise((resolve, reject) => {
          let payload_post = Object.keys(this.recipient_consents).map(c => {
            return {
              code: c,
              consent_value: this.recipient_consents[c].consent_value,
              consent_valid: this.recipient_consents[c].consent_valid
            }
          }).filter(e => e.consent_valid !== true);
          let payload_put = Object.keys(this.recipient_consents).map(c => {
            return {
              code: c,
              consent_value: this.recipient_consents[c].consent_value,
              consent_valid: this.recipient_consents[c].consent_valid
            }
          }).filter(e => e.consent_valid === true);

          axios.post('/api/consents', { consents: payload_post })
          .then(() => {
            axios.put('/api/consents', { consents: payload_put })
            .then(response => {
              resolve(response);
            })
            .catch(error => {
              console.error(error);
              reject(error);
            })
          })
          .catch(error => {
            console.error(error);
            reject(error);
          })
          .finally(() => {
            this.getRecipientConsents()
          })
			})
		},
		toggleConsent(code){
			let recipient_consent = this.recipient_consents[code]; 
			recipient_consent.consent_value = !recipient_consent.consent_value;
		},
    returnToRoute() {
      this.goToCartOpen = false
      this.$router.push(this.returnRoute.path)
      this.$store.dispatch('phenotypeModule/clearReturnRoute')
    },
    goToPartnerPhenotype() {
      this.goToCartOpen = false
      this.$store.dispatch('phenotypeModule/setCurrentPhenotype', 'partner')
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goToCart() {
      this.goToCartOpen = false
      this.$router.push({name: 'cartView'})
      this.$store.dispatch('phenotypeModule/clearReturnRoute')
    },
    returnToLinkName() {
      let linkName = '';
      switch (this.returnRoute.name) {
        case 'search':
          linkName = this.$t('page.search_back_name')
          break;
        case 'resultsView':
          linkName = this.$t('page.search_results_back_name')
          break;
        case 'donorDetails':
          linkName = this.$t('page.donor_details_back_name')
          break;
        case 'dashboardView':
          linkName = this.$t('page.favorite_profiles_back_name')
          break;
        case 'cartView':
          linkName = this.$t('page.reservations_back_name')
          break;
      }

      return linkName;
    },
    getAllPhenotypeOptions() {
      this.phenotypeOptions = require('../assets/phenotype/phenotype-options');
      this.setPhenotypeOptions()
      return !!this.phenotypeOptions;
    },
    getCurrentPhenotype() {
      this.validationOn = false;
      axios
        .get(`/api/phenotype/${this.currentPhenotype}`)
        .then((response) => {
          this.setSelectedPhenotypeOptions(response.data.observable_phenotype);
          this.$store.dispatch('phenotypeModule/setPhenotype', {
            'data': this.prepareObservablePhenotype(response.data.observable_phenotype),
            'mode': this.currentPhenotype
          });
          this.validationOn = true;
        })
        .catch(err => {
          console.error(err);
          this.editMode = true
          this.$store.dispatch('phenotypeModule/setPhenotype', {
            'data': {},
            'mode': this.currentPhenotype
          });
        });
    },
    resetPhenotype() {
      this.phenotype = {
        "own": {},
        "partner": {}
      }
    },
    prepareObservablePhenotype(observablePhenotype) {
      return {
        ...observablePhenotype,
        'ethnicity': {'key': observablePhenotype.ethnicity},
        'race': {'key': observablePhenotype.race},
        'skinColor': {'key': observablePhenotype.skinColor},
        'secondaryEthnicity': observablePhenotype.secondaryEthnicity.map(item => ({key: item})),
      }
    },
    setPhenotypeOptions() {
      this.genderOptions = this.phenotypeOptions.gender.map(item => ({key: item}));
      this.eyeColorOptions = this.phenotypeOptions.eyeColor.map(item => ({key: item}));
      this.hairColorOptions = this.phenotypeOptions.hairColor.map(item => ({key: item}));
      this.hairShapeOptions = this.phenotypeOptions.hairShape.map(item => ({key: item}));
      this.bloodTypeOptions = this.phenotypeOptions.bloodType.map(item => ({key: item}));
      this.bloodRhFactorOptions = this.phenotypeOptions.bloodRhFactor.map(item => ({key: item}));
      this.bodyTypeOptions = this.phenotypeOptions.bodyType.map(item => ({key: item})).reverse();
      this.ethnicityOptions = this.phenotypeOptions.ethnicity.map(item => ({key: item}));
      this.raceOptions = this.phenotypeOptions.race.map(item => ({key: item}));
      this.skinColorOptions = this.phenotypeOptions.skinColor.map(item => ({key: item}));
      this.secondaryEthnicityOptions = this.phenotypeOptions.secondaryEthnicity.map(item => ({key: item}));
    },
    setSelectedPhenotypeOptions(phenotype) {
      this.selectedGender = phenotype.gender ?? null;
      this.selectedEyeColor = phenotype.eyeColor ? [{'key': phenotype.eyeColor}] : [];
      this.selectedHairColor = phenotype.hairColor ? [{'key': phenotype.hairColor}] : [];
      this.selectedHairShape = phenotype.hairShape ? [{'key': phenotype.hairShape}] : [];
      this.selectedBloodType = phenotype.bloodType ?? null;
      this.selectedBloodRhFactor = phenotype.bloodRhFactor ?? null;
      this.bodyType = phenotype.bodyType ?? null;
      this.height = phenotype.height ?? null;
      this.weight = phenotype.weight ?? null;
      this.selectedEthnicity = phenotype.ethnicity ? [{'key': phenotype.ethnicity}] : [];
      this.selectedRace = phenotype.race ? [{'key': phenotype.race}] : [];
      this.selectedSkinColor = phenotype.skinColor ? [{'key': phenotype.skinColor}] : [];
      this.selectedSecondaryEthnicity = phenotype.secondaryEthnicity ? phenotype.secondaryEthnicity.map(item => ({key: item})) : [];
    },
    setBodyType() {
      if (this.height && this.weight && this.selectedGender) {
        let bodyType = null;
        let factor = this.height / this.weight ** (1/3);

        if (this.selectedGender == 'MALE') {
          if (factor < 39.5) {
            bodyType = 'ENDOMORPH_BODY_TYPE'
          } else if (factor >= 39.5 && factor <= 43.2) {
            bodyType = 'MESOMORPH_BODY_TYPE'
          } else if (factor > 43.2) {
            bodyType = 'ECTOMORPH_BODY_TYPE'
          }
        } else if (this.selectedGender == 'FEMALE') {
          if (factor < 40.7) {
            bodyType = 'ENDOMORPH_BODY_TYPE'
          } else if (factor >= 40.7 && factor <= 42.3) {
            bodyType = 'MESOMORPH_BODY_TYPE'
          } else if (factor > 42.3) {
            bodyType = 'ECTOMORPH_BODY_TYPE'
          }
        }

        this.bodyType = bodyType
      } else {
        this.bodyType = null
      }
    },
    validateField(field) {
      if(this.genderValidationOn) {
        switch(field) {
          case "selectedOppositeGender": {
            if((this.currentPhenotype == 'own' && this.storedPhenotype?.partner?.gender) ||
            (this.currentPhenotype == 'partner' && this.storedPhenotype?.own?.gender)) {
              return this.selectedGender != (this.currentPhenotype == 'own' ? this.storedPhenotype.partner.gender : this.storedPhenotype.own.gender);
            } else {
              return true;
            }
          }
        }
      }
      if(this.validationOn) {
        switch(field) {
          case "selectedEthnicity": {
            return this.selectedEthnicity.length > 0;
          }
          case "selectedRace": {
            return this.selectedRace.length > 0;
          }
          case "selectedSkinColor": {
            return this.selectedSkinColor.length > 0;
          }
          default: {
            if(this[field] && Array.isArray(this[field])) {
              return this[field].length > 0;
            } else {
              return this[field];
            }
          }
        }
      } else {
        return true;
      }
    },
    validatePhenotype() {
      let result = this.selectedGender &&
      this.selectedEyeColor &&
      this.selectedHairColor &&
      this.selectedHairShape &&
      this.selectedBloodType &&
      this.selectedBloodRhFactor &&
      this.bodyType &&
      this.height &&
      this.weight &&
      this.selectedRace &&
      this.selectedSkinColor &&
      this.selectedRace.length > 0 &&
      this.selectedSkinColor.length > 0;
      return result;
    },
    editPhenotype() {
      this.editMode = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    confirmPhenotype(change) {
      this.change = change;
      this.consents.forEach((consent) => {
        this.validateConsent(consent.code);
      })
      this.validationOn = true;
      let errors = document.querySelector('.validation');
      if(errors) {
        this.confirmationOpen = false;
        this.$nextTick(() => {
          errors.scrollIntoView({behavior: 'smooth', block: 'center'});
        })
      } else {
        this.confirmationOpen = true;
      }
    },
    savePhenotype() {
      this.validationOn = true;
      let result = null;
      let consent_errors = document.querySelector('.validation_consent');
      if(consent_errors) {
        return;
      } else  {
        if(this.validatePhenotype()) {
          let data = {
            observable_phenotype: {
              ...this.phenotype[this.currentPhenotype],
              ethnicity: this.selectedEthnicity[0]?.key,
              race: this.selectedRace[0].key,
              skinColor: this.selectedSkinColor[0].key,

              eyeColor: this.selectedEyeColor[0].key,
              hairColor: this.selectedHairColor[0].key,
              hairShape: this.selectedHairShape[0].key,

              secondaryEthnicity: this.selectedSecondaryEthnicity.map(e => e.key)
            }
          }
          this.loading_save = true;
          this.hideConsentContent = true;
          this.sendConsent()
          .then(() => {
            axios
            .post(`/api/phenotype/${this.currentPhenotype}`, data)
            .then(() => {
              this.$store.dispatch('phenotypeModule/setPhenotype', {
                'data': this.prepareObservablePhenotype(data.observable_phenotype),
                'mode': this.currentPhenotype
              });
              result = true;
              if (this.returnRoute?.reservation) {
                this.goToCartOpen = true;
              }
            })
            .catch(err => {
              console.error(err);
              result = false;
              this.confirmationOpen = false;
              let error = document.querySelector('.validation');
              this.$nextTick(() => {
                error.scrollIntoView({behavior: 'smooth', block: 'center'});
              })
            })
            .finally(() => {
              // here we trigger phenotype fetch by changing currentPhenotype
              // ------------
              if(this.type == 'complete') {
                if(this.currentPhenotype == "own") {
                  this.store.dispatch('phenotypeModule/setCurrentPhenotype','partner')
                  this.editMode = true;
                  this.confirmationOpen = false;
                  this.loading_save = false;
                  this.$nextTick(() => {
                    this.$router.push({
                      name: 'completePhenotypeView',
                      params: {
                        type: 'partner',
                      }
                    });
                    window.scrollTo({ top: 0, behavior: 'smooth'})
                  })
                  
                  
                } else {
                  this.confirmationOpen = false;
                  this.loading_save = false;
                  this.store.dispatch('resultsModule/setSearchForSimilar', true).then(
                    () => {
                      this.$router.push({name: 'resultsView'})
                      window.scrollTo({ top: 0, behavior: 'smooth'})
                    }
                  )
                }
              } else if (this.type == 'reservation') {
                this.editMode = true;
                this.confirmationOpen = false;
                this.loading_save = false;
                if(this.currentPhenotype == "own") {
                  this.store.dispatch('phenotypeModule/setCurrentPhenotype','partner')
                  this.$nextTick(() => {
                    this.$router.push({
                      name: 'reservationPhenotypeView',
                      params: {
                        type: 'partner',
                      }
                    });
                    window.scrollTo({ top: 0, behavior: 'smooth'})
                  })
                } else {
                  this.$nextTick(() => {
                    this.$router.push({name: 'confirmationView'})
                    window.scrollTo({ top: 0, behavior: 'smooth'})
                  });
                }
              } else {
              // ------------
                this.editMode = false;
                this.confirmationOpen = false;
                this.$nextTick(() => {
                  if(this.change) {
                    if(this.currentPhenotype == "own") {
                      this.store.dispatch('phenotypeModule/setCurrentPhenotype','partner');
                    } else {
                      this.store.dispatch('phenotypeModule/setCurrentPhenotype','own');
                    }
                  }
                  this.showSavePhenotypeAlert(result);
                })
              }
            });
          })
          .catch((err) => {
            console.error(err);
            this.confirmationOpen = false;
            let error = document.querySelector('.validation');
            this.$nextTick(() => {
              this.showSavePhenotypeAlert(false);
              error.scrollIntoView({behavior: 'smooth', block: 'center'});
            })
          })
          .finally(() => {
            this.loading_save = false;
            setTimeout(() => {
              this.hideConsentContent = false;
            },1000);
          })
          
        } else {
          this.$nextTick(() => {
            this.loading_save = false;
            let error = document.querySelector('.validation');
            if(error) {
              this.confirmationOpen = false;
              let error = document.querySelector('.validation');
              this.$nextTick(() => {
                error.scrollIntoView({behavior: 'smooth', block: 'center'});
              })
            }
          })
        }
      }
    },
    showSavePhenotypeAlert(result = false) {
      this.$root.$alertMessageRef.showAlert(
        this.$t(
          `alert.PHENOTYPE_SAVE_${result ? 'SUCCESS' : 'FAILURE'}.title`
        ),
        null,
        {
          link: false,
          action: false,
          timeout: true,
          timeoutDuration: 3000,
          color: 'rgba(32, 30, 76, 1)',
          backgroundColor: result ? 'rgba(107, 215, 131, 0.2)' : 'rgba(232, 69, 69, 0.2)',
          borderColor: result ? 'rgba(107, 215, 131, 1)' : 'rgba(232, 69, 69, 1)',
          icon: result ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
          iconColor: result ? 'rgba(107, 215, 131, 1)' : 'rgba(232, 69, 69, 1)',
          width: '600px'
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.square {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  border: 1px solid var(--nsb-color-3, #EEF4FE);
  &[id='ECTOMORPH_BODY_TYPE'] { // thin
    background: url('../assets/svg/thin.svg');
    background-size: 48px 48px;
    background-position: center center;
    background-repeat: no-repeat;
    &.filter_selected {
      background: url('../assets/svg/thin-selected.svg'), var(--Invicta-Navy-300, #00205B);
      background-size: 48px 48px;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
  &[id='MESOMORPH_BODY_TYPE'] { // middle
    background: url('../assets/svg/medium.svg');
    background-size: 48px 48px;
    background-position: center center;
    background-repeat: no-repeat;
    &.filter_selected {
      background: url('../assets/svg/medium-selected.svg'), var(--Invicta-Navy-300, #00205B);
      background-size: 48px 48px;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
  &[id='ENDOMORPH_BODY_TYPE'] { // thick
    background: url('../assets/svg/thick.svg');
    background-size: 48px 48px;
    background-position: center center;
    background-repeat: no-repeat;
    &.filter_selected {
      background: url('../assets/svg/thick-selected.svg'), var(--Invicta-Navy-300, #00205B);
      background-size: 48px 48px;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
  &[id='ECTOMORPH_BODY_TYPE_MALE'] { // thin
    background: url('../assets/svg/thin_male.svg');
    background-size: 48px 48px;
    background-position: center center;
    background-repeat: no-repeat;
    &.filter_selected {
      background: url('../assets/svg/thin-selected_male.svg'), var(--Invicta-Navy-300, #00205B);
      background-size: 48px 48px;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
  &[id='MESOMORPH_BODY_TYPE_MALE'] { // middle
    background: url('../assets/svg/medium_male.svg');
    background-size: 48px 48px;
    background-position: center center;
    background-repeat: no-repeat;
    &.filter_selected {
      background: url('../assets/svg/medium-selected_male.svg'), var(--Invicta-Navy-300, #00205B);
      background-size: 48px 48px;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
  &[id='ENDOMORPH_BODY_TYPE_MALE'] { // thick
    background: url('../assets/svg/thick_male.svg');
    background-size: 48px 48px;
    background-position: center center;
    background-repeat: no-repeat;
    &.filter_selected {
      background: url('../assets/svg/thick-selected_male.svg'), var(--Invicta-Navy-300, #00205B);
      background-size: 48px 48px;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
}
:deep(.tooltip--container) {
  position: absolute;
  .icon {
    margin-top: -2px !important;
    width: 24px !important;
    height: 24px !important;
  }
}
.gender { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 36px; }
}
.eye-color { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 80px; }
}
.hair-color { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 98px; }
}
.hair-shape { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 126px; }
}
.height { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 54px; }
}
.weight { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 50px; }
}
.body-type { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 70px; }
}
.blood-type { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 82px; }
}
.blood-rh-factor { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 82px; }
}
.race { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 42px; }
}
.skin { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 48px; }
}
.ethnicity { position: relative;
  :deep(.tooltip--container) { top: 0px; left: 178px; }
}

.v-row {
  padding: 0px;
  margin: 0px;
}

.filters_header {
  color: var(--bank-primary, #00205B);
  @include nsb-gentium-bold;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: 145%; /* 33.35px */
  position: relative;
}

.filters_header_label {
  color: var(--bank-primary, #00205B);
  @include nsb-font-container;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
}

// * {
//   box-shadow: 0px 0px 2px inset red;
// }

h3 {
  @include nsb-font-header-bold;
  font-size: 16px;
}

#phenotype-container {
  // min-height: 100vh;
  background: white;
  position: relative;
  &.reservation {
    box-shadow: 0px 8px 16px 0px rgba(112, 144, 176, 0.20);
  }
}

.disabled {
  :deep(*){
    color: $nsb-color-4;
  }
  pointer-events: none;
}
:deep(.v-field__input) {
  max-width: 100px;
  .v-card {
    @include nsb-font-input;
    position: absolute;
    right: 16px;
    top: 9px;
  }
  input {
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
    &[type=number] {
      -moz-appearance: textfield;
    }
  }
}
:deep(.v-field--variant-outlined) {
  .v-field__outline {
    --v-field-border-opacity: 1;
    color: $ds-secondary-300;
    .v-field__outline__start {
      --v-field-border-width: 1px;
    }
    .v-field__outline__end {
      --v-field-border-width: 1px;
    }
  }
}
.validation_consent,
.validation {
  @include nsb-validation;
}

.button {
  @include nsb-font-button;
  font-size: 14px !important;
  min-height: 40px !important;
  min-width: 212px !important;
  &.long {
    width: 100%;
    height: auto;
    :deep(.v-btn__content) {
      white-space: normal;
    }
  }
}

.back-link {
  @include nsb-back-link;
  font-size: 14px;
  line-height: 21px;
  cursor: pointer;
  position: relative;
  text-decoration-line: underline;
}

:deep(.link) {
	text-decoration: underline !important;
}
.v-alert {
  z-index: 10;
  .v-alert__content {
    @include nsb-font-container;
    font-size: 14px;
    color: $ds-primary;
    line-height: 21px;
    margin: auto;
    margin-left: 0px;
  }

  .v-alert__prepend {
    font-size: 14px;
    color: $ds-primary;
    align-self: center;
  }
}

.edit {
  @include nsb-font-container-medium;
  font-size: 14px;
  line-height: 21px;
  position: absolute;
  top: 30px;
  right: 40px;
  cursor: pointer;
}

.phenotype-modal, .go-to-cart-modal {
  .modal {
    width: 690px !important;
    &-header {
      @include nsb-font-main-header;
      font-size: 23px !important;
    }
    &-text {
      @include nsb-font-container;
      font-size: 14px !important;
      line-height: 21px !important;
      // padding-right: 96px;
    }
    &-buttons {
      @include nsb-font-button-medium;
      font-size: 14px !important;
      line-height: 21px !important;
    }
    &-button-cancel {
      border: 1px solid transparent !important;
    }
  }
}
// --------------------------

.consent-wrapper {
	.consent {
		@include nsb-font-container;
		font-size: 12px;
		line-height: 18px;
	}
}

@media (min-width: 960px) {
  .phenotype-modal, .go-to-cart-modal {
    .modal {
      width: 690px !important;
      &-header {
        @include nsb-font-main-header;
        font-size: 23px !important;
      }
      &-text {
        @include nsb-font-container;
        font-size: 14px !important;
        line-height: 21px !important;
        padding-right: 96px;
      }
      &-buttons {
        @include nsb-font-button-medium;
        font-size: 14px !important;
        line-height: 21px !important;
      }
      &-button-cancel {
        border: 1px solid transparent !important;
      }
    }
  }
}

/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  box-sizing: border-box;
  border: 1px solid #869AB7;
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: $nsb-disabled;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: $ds-primary;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
